import { INPUT_TEXTAREA_DISPLAY_NAME } from "./core";
import createDisplayName from "../../../fabrics/createDisplayName";

export const createDisplayNameForInputTextAreaElement = createDisplayName(
    INPUT_TEXTAREA_DISPLAY_NAME,
);
